import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import FeePaymentDetailsEdit from './routes/FeePaymentDetailsEdit';

const FeePaymentDetailsLazy = React.lazy(
	() => import(/* webpackChunkName : 'FeePaymentDetails' */ './components')
);

export default (store) => [
	{
		path: 'home/fees/fee-payment/:studentId',
		element: <AsyncLoading component={<FeePaymentDetailsLazy />} />,
	},
	...FeePaymentDetailsEdit(store),
];
